export default __webpack_public_path__ + "static/media/micOffNew.1dadbe3a.svg";